import React from 'react';
import $ from 'jquery';
import {TweenMax, TimelineMax} from "gsap";
import ScrollMagic from 'scrollmagic';
import "../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap.js";

class Banner extends React.Component {
        render() {
          return (
          	<section className="team about-team">
			  <div className="teaminner2">
			    <div className="teaminner">
			      <div className="teaminnermain">
			        <div className="container">
			          <div className="row">
			            <div className="col-md-7 breeserif titletext">
			              <h1 className="breeserif titletext">About Most<br/>Valuable Personnel</h1>
			            </div>
			            <div className="col-md-5 visible-lg"><img src="images/MVP-Hero-Circle-2.png" alt="" className="img-responsive center-block" /></div>
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			</section>
          );
        }
}

class AboutSvg extends React.Component {
	componentDidMount() {
			$(".one-text, .two-text").css({"display":"none"});
			function next(){
				$(".two-text").css({"display":"block"});
				TweenMax.staggerFromTo($(".two-text"), 0.01, {autoAlpha:0}, {autoAlpha:1}, 0.06 );
			}

			$(".one-text").css({"display":"block"});
			TweenMax.staggerFromTo($(".one-text"), 0.01, {autoAlpha:0}, {autoAlpha:1}, 0.06, next );
    	}
	  render() {
          return (
    <div>

<svg  version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 577.5">
<g>
	<g>
		<g>
			<polygon className="st012" points="776,366.1 698.9,320.5 162.9,320.5 162.9,411.8 698.9,411.8 			"/>
		</g>
	</g>
		<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="172.4" y1="85.85" x2="755.7" y2="85.85" gradientTransform="matrix(1 0 0 -1 0 452)">
		<stop  offset="0.1714" style={{"stop-color":"#3DBAB1"}}>
			<animate begin="1s" attributeName="offset" from="0" to=".1714"
        dur="1s" />
		</stop>
		<stop  offset="0.3474" style={{"stop-color":"#3BB3B3"}}>
			<animate begin="1s" attributeName="offset" from="0" to=".3474"
        dur="1s" />
		</stop>
		<stop  offset="0.5254" style={{"stop-color":"#36A7B6"}}>
			<animate begin="1s" attributeName="offset" from="0" to=".5254"
        dur="1s" />
		</stop>
		<stop offset="0.7049" style={{"stop-color":"#3198B9"}}>
			<animate begin="1s" attributeName="offset" from="0" to=".7049"
        dur="1s"/>
		</stop>
		<stop offset="0.8839" style={{"stop-color":"#2D83B9"}}>
				<animate begin="1s" attributeName="offset" from="0" to=".8839"
        dur="1s" />
        </stop>
	</linearGradient>
	<polygon className="st111" points="693,401.8 172.4,401.8 172.4,330.5 693,330.5 755.7,366.1 	"/>
</g>
<g>
	<g>
		<g>
			<polygon className="st011" points="776,225.4 698.9,179.7 162.9,179.7 162.9,271 698.9,271 			"/>
		</g>
	</g>
		<linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="172.4" y1="85.85" x2="755.7" y2="85.85" gradientTransform="matrix(1 0 0 -1 0 452)">
		<stop  offset="0.1714" style={{"stop-color":"#3DBAB1"}}>
			<animate attributeName="offset" from="0" to=".1714"
        dur="1s" />
		</stop>
		<stop  offset="0.3474" style={{"stop-color":"#3BB3B3"}}>
			<animate attributeName="offset" from="0" to=".3474"
        dur="1s" />
		</stop>
		<stop  offset="0.5254" style={{"stop-color":"#36A7B6"}}>
			<animate attributeName="offset" from="0" to=".5254"
        dur="1s" />
		</stop>
		<stop  offset="0.7049" style={{"stop-color":"#3198B9"}}>
			<animate attributeName="offset" from="0" to=".7049"
        dur="1s"/>
		</stop>
		<stop  offset="0.8839" style={{"stop-color":"#2D83B9"}}>
				<animate attributeName="offset" from="0" to=".8839"
        dur="1s" />
        </stop>
	</linearGradient>
	<polygon className="st112" points="693,261 172.4,261 172.4,189.7 693,189.7 755.7,225.4 	"/>
</g>
<g>
	<path className="st13" d="M75.7,33.7c0,4-1.9,7.1-4.9,10.5l-9.6,11.1h16.2V60H53.1v-4.2L64.8,42c2.9-3.4,4-5.1,4-8
		c0-3.4-2.4-4.8-5.7-4.8c-1.7,0-2.9,0.3-3.6,0.5c-0.9,0.3-1,0.7-1,1.6V35l-5.3-0.4v-8.2c2.6-1.5,6.5-2.5,10.9-2.5
		C71.5,23.9,75.7,27.9,75.7,33.7z"/>
	<path className="st13" d="M105.8,42c0,13-4.6,18.6-13,18.6S80.1,55,80.1,42.2c0-12.6,5.2-18.3,13.1-18.3C100.9,23.9,105.8,29,105.8,42z
		 M99.2,42.1c0-10.1-2.5-12.9-6.2-12.9c-4,0-6.3,3.1-6.3,13.5c0,9.6,2.3,12.5,6.2,12.5C96.7,55.3,99.2,52.6,99.2,42.1z"/>
	<path className="st13" d="M135.5,42c0,13-4.6,18.6-13,18.6s-12.7-5.6-12.7-18.4c0-12.6,5.2-18.3,13.1-18.3C130.6,23.9,135.5,29,135.5,42
		z M128.9,42.1c0-10.1-2.5-12.9-6.2-12.9c-4,0-6.3,3.1-6.3,13.5c0,9.6,2.3,12.5,6.2,12.5C126.4,55.3,128.9,52.6,128.9,42.1z"/>
	<path className="st13" d="M165.2,42c0,13-4.6,18.6-13,18.6s-12.7-5.6-12.7-18.4c0-12.6,5.2-18.3,13.1-18.3C160.3,23.9,165.2,29,165.2,42
		z M158.6,42.1c0-10.1-2.5-12.9-6.2-12.9c-4,0-6.3,3.1-6.3,13.5c0,9.6,2.3,12.5,6.2,12.5C156.1,55.3,158.6,52.6,158.6,42.1z"/>
</g>
<g>
	<path className="st14" d="M835.4,33.7c0,4-1.9,7.1-4.9,10.5l-9.6,11.1H837V60h-24.2v-4.2L824.6,42c2.9-3.4,4-5.1,4-8
		c0-3.4-2.4-4.8-5.7-4.8c-1.7,0-2.9,0.3-3.6,0.5c-0.9,0.3-1,0.7-1,1.6V35l-5.3-0.4v-8.2c2.6-1.5,6.5-2.5,10.9-2.5
		C831.2,23.9,835.4,27.9,835.4,33.7z"/>
	<path className="st14" d="M865.5,42c0,13-4.6,18.6-13,18.6s-12.7-5.6-12.7-18.4c0-12.6,5.2-18.3,13.1-18.3C860.6,23.9,865.5,29,865.5,42
		z M859,42.1c0-10.1-2.5-12.9-6.2-12.9c-4,0-6.3,3.1-6.3,13.5c0,9.6,2.3,12.5,6.2,12.5C856.4,55.3,859,52.6,859,42.1z"/>
	<path className="st14" d="M878.2,31l-7.5,3.9l-2.1-3.7l10.7-6.5h5.4v30.9l6.2,0.3V60h-19.2v-4l5.1-0.3c1-0.1,1.5-0.2,1.5-1.7V31H878.2z"
		/>
	<path className="st14" d="M899.9,29.5c-1,0-1.3,0.4-1.3,1.5v2.8l-5.3-0.4v-8.7h24v4.2L902.6,60h-7l14.7-30.6h-10.4V29.5z"/>
</g>
<g>
	<linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="119" y1="355.9" x2="854.4" y2="355.9" gradientTransform="matrix(1 0 0 -1 0 452)">
		<stop  offset="0" style={{"stop-color":"#3CBEB1"}} />
		<stop  offset="1" style={{"stop-color":"#2A74BB"}} />
	</linearGradient>
	<line className="st15" x1="854.4" y1="96.1" x2="119" y2="96.1"/>
	<circle className="st13" cx="109" cy="96.1" r="10"/>
	<circle className="st14" cx="864.4" cy="96.1" r="10"/>
</g>
<g>
	<path className="st13" d="M107.5,211l-7.5,3.9l-2.1-3.7l10.7-6.5h5.4v30.9l6.2,0.3v4.2H101V236l5.1-0.3c1-0.1,1.5-0.2,1.5-1.7L107.5,211
		L107.5,211z"/>
</g>
<g>
	<path className="st01 one-text" d="M245,234.5l3.1-1.4c0.9,2.9,3.6,4.3,6.7,4.3c2.8,0,6.1-1.3,6.1-4.2c0-2.4-2.2-3.7-5.7-5
		c-3.8-1.4-6.7-3.1-6.7-6.7c0-4.9,4-7.7,9.2-7.7c3.6,0,7.2,1.2,8.5,5l-2.8,1.2c-1.1-2.2-3.2-3.2-5.8-3.2c-2.8,0-5.7,1.3-5.7,4.2
		c0,2.1,2.6,3.3,6.5,4.9c3.2,1.3,5.8,3.3,5.8,6.5c0,5.4-4.6,8-9.8,8C250.3,240.5,246.6,238.8,245,234.5z"/>
	<path className="st01 one-text" d="M268.2,237.1c0-0.3,0-0.6,0.1-1l2.1-11.6h-3l0.4-2.6h3l1-5.7h3.2l-1,5.7h4.6l-0.5,2.6h-4.6l-1.9,10.8
		c0,0.3-0.1,0.5-0.1,0.7c0,1.1,0.7,1.5,1.9,1.5c0.8,0,1.7-0.1,2.5-0.3l-0.4,2.7c-1.2,0.3-2.3,0.4-3.3,0.4
		C270.2,240.3,268.2,239.5,268.2,237.1z"/>
	<path className="st01 one-text" d="M279.4,235.3c0-0.5,0-0.9,0.1-1.4c0.2-1,0.8-4.2,0.9-5.2c0.8-4.5,3.9-7.1,8.1-7.1c1.9,0,4.2,0.9,4.9,2.9h0.1
		l0.5-2.5h3.1l-3.2,18.2h-3.1l0.5-2.8h-0.1c-1.5,2.1-4.2,3.2-6.1,3.2C281.7,240.5,279.4,238.6,279.4,235.3z M292,232.9l0.7-4.1
		c0-0.3,0.1-0.6,0.1-0.9c0-2.4-1.9-3.7-4.1-3.7c-2.4,0-4.5,1.5-4.9,4.2l-0.9,5.3c0,0.3-0.1,0.5-0.1,0.8c0,2.1,1.5,3.2,3.7,3.2
		C288.9,237.7,291.5,235.9,292,232.9z"/>
	<path className="st01 one-text" d="M300.2,237.1c0-0.3,0-0.6,0.1-1l2.1-11.6h-3l0.4-2.6h3l1-5.7h3.2l-1,5.7h4.6l-0.5,2.6h-4.6l-1.9,10.8
		c0,0.3-0.1,0.5-0.1,0.7c0,1.1,0.7,1.5,1.9,1.5c0.8,0,1.7-0.1,2.5-0.3l-0.4,2.7c-1.2,0.3-2.3,0.4-3.3,0.4
		C302.2,240.3,300.2,239.5,300.2,237.1z"/>
	<path className="st01 one-text" d="M311.4,234.7c0-1.3,0.4-2.9,0.8-5.4c0.9-4.8,4.6-7.8,9.3-7.8c3.6,0,6.3,1.8,6.3,5.5c0,1.2-0.3,2.8-0.6,4.7
		h-12.1c-0.3,1.4-0.4,2-0.4,2.6c0,2.3,1.8,3.5,4.2,3.5c2.7,0,4.9-1.2,6-1.9l1,2.1c-1.7,1.6-4.8,2.4-7.7,2.4
		C314.6,240.5,311.4,238.8,311.4,234.7z M324.4,229.5c0.1-1,0.2-1.4,0.2-1.9c0-2.1-1.3-3.3-3.6-3.3c-2.9,0-4.7,1.9-5.3,4.2
		c-0.1,0.2-0.2,0.8-0.2,1H324.4z"/>
	<path className="st01 one-text" d="M329.1,237.7l2-1.9c1.3,1.2,3.1,2.1,5.2,2.1c2,0,4.6-0.6,4.6-3.1c0-1.5-1.7-2.1-3.7-2.8
		c-3.1-1.1-5.4-2.1-5.4-4.9c0-3.5,3-5.7,7.2-5.7c2.4,0,4.6,0.5,6.2,2.1l-1.9,2c-1.1-0.9-2.8-1.6-4.6-1.6c-1.9,0-3.9,0.9-3.9,2.8
		c0,1.1,0.9,1.6,2.4,2.2c2.9,1.2,6.9,2.2,6.9,5.4c0,4.6-4.1,6.1-7.8,6.1C333.3,240.5,330.6,239.7,329.1,237.7z"/>
	<path className="st01 one-text" d="M355.3,221.9h3.3l1.5,14h0.1l6.6-14h2.9l1.7,14h0.1l6.5-14h3.3l-9,18.2h-3.2l-1.7-14h-0.1l-6.5,14h-3.2
		L355.3,221.9z"/>
	<path className="st01 one-text" d="M381.3,234.7c0-1.3,0.4-2.9,0.8-5.4c0.9-4.8,4.6-7.8,9.3-7.8c3.6,0,6.3,1.8,6.3,5.5c0,1.2-0.3,2.8-0.6,4.7H385
		c-0.3,1.4-0.4,2-0.4,2.6c0,2.3,1.8,3.5,4.2,3.5c2.7,0,4.9-1.2,6-1.9l1,2.1c-1.7,1.6-4.8,2.4-7.7,2.4
		C384.5,240.5,381.3,238.8,381.3,234.7z M394.3,229.5c0.1-1,0.2-1.4,0.2-1.9c0-2.1-1.3-3.3-3.6-3.3c-2.9,0-4.7,1.9-5.3,4.2
		c-0.1,0.2-0.2,0.8-0.2,1H394.3z"/>
	<path className="st01 one-text" d="M407.5,235.3c0-0.5,0-0.9,0.1-1.4l0.9-5.2c0.8-4.5,4-7.1,8.1-7.1c1.9,0,4.2,0.9,4.9,2.9h0.1l1.8-10h3.2
		l-4.5,25.7H419l0.5-2.8h-0.1c-1.5,2.1-4.2,3.2-6.1,3.2C409.9,240.5,407.5,238.6,407.5,235.3z M420.1,232.9l0.7-4.1
		c0.1-0.3,0.1-0.6,0.1-1c0-2.4-1.8-3.7-4-3.7c-2.4,0-4.6,1.5-5.1,4.2l-1,5.3c0,0.3-0.1,0.5-0.1,0.8c0,2.1,1.5,3.2,3.7,3.2
		C417,237.7,419.6,235.9,420.1,232.9z"/>
	<path className="st01 one-text" d="M427.3,234.9c0-0.5,0.1-0.9,0.1-1.5l0.8-4.5c0.8-4.5,4.7-7.4,9.1-7.4c3.8,0,6.7,2,6.7,5.8
		c0,0.5-0.1,1.1-0.1,1.6l-0.7,4.2c-0.8,4.5-4.6,7.4-9,7.4C430.4,240.5,427.3,238.8,427.3,234.9z M439.8,233.3l0.8-4.7
		c0.1-0.4,0.1-0.7,0.1-1c0-2.2-1.6-3.3-3.9-3.3c-2.9,0-4.9,1.8-5.3,4.5l-0.8,4.7c-0.1,0.4-0.1,0.7-0.1,1c0,2.2,1.5,3.3,3.9,3.3
		C437.4,237.8,439.3,236.1,439.8,233.3z"/>
	<path className="st01 one-text" d="M457.3,237.6h-0.1c-0.1,0.3-0.5,2.2-0.5,2.5h-3l4.5-25.7h3.2l-1.8,10.2h0.1c1.5-2,3.9-3,6-3
		c3.4,0,5.7,1.9,5.7,5.3c0,0.5,0,0.9-0.1,1.4c-0.2,1.1-0.7,4.1-0.9,5.2c-0.8,4.6-4.3,7.1-8.5,7.1
		C459.9,240.5,457.9,239.4,457.3,237.6z M467,233.6l0.9-5.3c0-0.3,0.1-0.5,0.1-0.8c0-2.2-1.6-3.2-3.8-3.2c-2.5,0-5,1.9-5.5,5l-0.7,4
		c0,0.3-0.1,0.6-0.1,0.9c0,2.4,1.8,3.7,4,3.7C464.5,237.8,466.5,236.3,467,233.6z"/>
	<path className="st01 one-text" d="M474.1,235.7c0-0.5,0.1-1.1,0.1-1.6l2.2-12.2h3.2l-2,11.2c-0.1,0.4-0.2,1.3-0.2,1.7c0,2.1,1.2,2.9,3.2,2.9
		c2.9,0,5.1-2.4,5.6-5.3l1.9-10.4h3.2c-0.3,1.7-2.9,16.5-3.2,18.2H485l0.5-2.8h-0.1c-1.6,2.1-3.9,3.2-6.2,3.2
		C475.9,240.4,474.1,238.6,474.1,235.7z"/>
	<path className="st01 one-text" d="M492.3,237.7l2-1.9c1.3,1.2,3.1,2.1,5.2,2.1c2,0,4.6-0.6,4.6-3.1c0-1.5-1.7-2.1-3.7-2.8
		c-3.1-1.1-5.4-2.1-5.4-4.9c0-3.5,3-5.7,7.2-5.7c2.4,0,4.6,0.5,6.2,2.1l-1.9,2c-1.1-0.9-2.8-1.6-4.6-1.6c-1.9,0-3.9,0.9-3.9,2.8
		c0,1.1,0.9,1.6,2.4,2.2c2.9,1.2,6.9,2.2,6.9,5.4c0,4.6-4.1,6.1-7.8,6.1C496.5,240.5,493.8,239.7,492.3,237.7z"/>
	<path className="st01 one-text" d="M513.3,221.9h3.2l-3.2,18.2h-3.2L513.3,221.9z M514.6,214.4h3.2l-0.8,4.2h-3.2L514.6,214.4z"/>
	<path className="st01 one-text" d="M521.6,221.9h3.1l-0.5,2.8h0.1c1.6-2.1,3.9-3.2,6.3-3.2c3.2,0,5.1,2.1,5.1,4.5c0,0.5-0.1,1.3-0.2,1.8
		l-2.2,12.2h-3.2l2-11.2c0.1-0.4,0.2-1.2,0.2-1.7c0-1.9-1.2-2.8-3.2-2.8c-2.9,0-5.1,2.3-5.6,5.3l-1.8,10.4h-3.2
		C518.6,238.4,521.3,223.6,521.6,221.9z"/>
	<path className="st01 one-text" d="M538.3,234.7c0-1.3,0.4-2.9,0.8-5.4c0.9-4.8,4.6-7.8,9.3-7.8c3.6,0,6.3,1.8,6.3,5.5c0,1.2-0.3,2.8-0.6,4.7H542
		c-0.3,1.4-0.4,2-0.4,2.6c0,2.3,1.8,3.5,4.2,3.5c2.7,0,4.9-1.2,6-1.9l1,2.1c-1.7,1.6-4.8,2.4-7.7,2.4
		C541.5,240.5,538.3,238.8,538.3,234.7z M551.3,229.5c0.1-1,0.2-1.4,0.2-1.9c0-2.1-1.3-3.3-3.6-3.3c-2.9,0-4.7,1.9-5.3,4.2
		c-0.1,0.2-0.2,0.8-0.2,1H551.3z"/>
	<path className="st01 one-text" d="M556,237.7l2-1.9c1.3,1.2,3.1,2.1,5.2,2.1c2,0,4.6-0.6,4.6-3.1c0-1.5-1.7-2.1-3.7-2.8
		c-3.1-1.1-5.4-2.1-5.4-4.9c0-3.5,3-5.7,7.2-5.7c2.4,0,4.6,0.5,6.2,2.1l-1.9,2c-1.1-0.9-2.8-1.6-4.6-1.6c-1.9,0-3.9,0.9-3.9,2.8
		c0,1.1,0.9,1.6,2.4,2.2c2.9,1.2,6.9,2.2,6.9,5.4c0,4.6-4.1,6.1-7.8,6.1C560.2,240.5,557.5,239.7,556,237.7z"/>
	<path className="st01 one-text" d="M572.7,237.7l2-1.9c1.3,1.2,3.1,2.1,5.2,2.1c2,0,4.6-0.6,4.6-3.1c0-1.5-1.7-2.1-3.7-2.8
		c-3.1-1.1-5.4-2.1-5.4-4.9c0-3.5,3-5.7,7.2-5.7c2.4,0,4.6,0.5,6.2,2.1l-1.9,2c-1.1-0.9-2.8-1.6-4.6-1.6c-1.9,0-3.9,0.9-3.9,2.8
		c0,1.1,0.9,1.6,2.4,2.2c2.9,1.2,6.9,2.2,6.9,5.4c0,4.6-4.1,6.1-7.8,6.1C577,240.5,574.3,239.7,572.7,237.7z"/>
	<path className="st01 one-text" d="M601.3,221.9h3.2l-3.2,18.2h-3.2L601.3,221.9z M602.6,214.4h3.2l-0.8,4.2h-3.2L602.6,214.4z"/>
	<path className="st01 one-text" d="M609.5,221.9h3.1l-0.5,2.8h0.1c1.6-2.1,3.9-3.2,6.3-3.2c3.2,0,5.1,2.1,5.1,4.5c0,0.5-0.1,1.3-0.2,1.8
		l-2.2,12.2H618l2-11.2c0.1-0.4,0.2-1.2,0.2-1.7c0-1.9-1.2-2.8-3.2-2.8c-2.9,0-5.1,2.3-5.6,5.3l-1.8,10.4h-3.2
		C606.6,238.4,609.3,223.6,609.5,221.9z"/>
</g>
<g>
	<g>
		<path className="st14" d="M858.4,216v10h4.9v4.8h-4.9v4.7l3.5,0.3v4.2h-13.6v-4.1l2.4-0.2c1-0.1,1.4-0.4,1.4-1.6v-3.3h-14.8v-4.2
			l10.9-22.8l5.1,2.6l-9.3,19.7h8.6l0.4-3.4l1.8-6.7H858.4z"/>
		<path className="st14" d="M887.3,216v10h4.9v4.8h-5v4.7l3.5,0.3v4.2h-13.6v-4.1l2.4-0.2c1-0.1,1.4-0.4,1.4-1.6v-3.3H866v-4.2l10.9-22.8
			l5.1,2.6l-9.3,19.7h8.6l0.4-3.4l1.8-6.7H887.3z"/>
	</g>
</g>
<g>
	<path className="st13" d="M121.9,364c0,13-4.6,18.6-13,18.6s-12.7-5.6-12.7-18.4c0-12.6,5.2-18.3,13.1-18.3
		C117,345.9,121.9,351,121.9,364z M115.4,364.1c0-10.1-2.5-12.9-6.2-12.9c-4,0-6.3,3.1-6.3,13.5c0,9.6,2.3,12.5,6.2,12.5
		C112.8,377.3,115.4,374.6,115.4,364.1z"/>
</g>
<g>
	<path className="st01 two-text" d="M303.5,352.1h16.9l-0.5,3.1h-13.4L305,363h11.5l-0.5,3.1h-11.5l-1.5,8.6h13.5l-0.5,3.1h-17L303.5,352.1z"/>
	<path className="st01 two-text" d="M323.4,359.5h3.1l-0.5,2.8h0.1c1.6-2.1,3.9-3.2,6.3-3.2c2.9,0,4.6,1.7,4.9,3.7c1.9-2.6,4.4-3.7,6.8-3.7
		c3.2,0,5.1,2.1,5.1,4.5c0,0.5-0.1,1.3-0.2,1.8c-0.2,1.3-1.9,10.9-2.2,12.2h-3.2l2-11.2c0.1-0.4,0.2-1.2,0.2-1.7
		c0-1.9-1.2-2.8-3.2-2.8c-2.9,0-5,2.3-5.6,5.2l-1.9,10.5h-3.2l2-11.2c0.1-0.4,0.2-1.2,0.2-1.7c0-1.9-1.2-2.8-3.2-2.8
		c-2.9,0-5.1,2.3-5.6,5.3l-1.8,10.4h-3.2L323.4,359.5z"/>
	<path className="st01 two-text" d="M355,359.5h3.1l-0.5,2.6h0.1c1.5-1.9,3.9-3,6-3c3.4,0,5.7,1.9,5.7,5.3c0,0.5,0,0.9-0.1,1.4
		c-0.2,1.1-0.8,4.2-0.9,5.2c-0.8,4.5-4.2,7.1-8.4,7.1c-1.9,0-3.9-1.1-4.5-3h-0.1l-1.7,9.5h-3.2L355,359.5z M365.2,371.2l0.9-5.3
		c0.1-0.3,0.1-0.5,0.1-0.8c0-2.1-1.7-3.2-3.9-3.2c-2.5,0-5,2-5.5,4.9l-0.7,4c0,0.3-0.1,0.6-0.1,0.9c0,2.4,1.8,3.7,4,3.7
		C362.5,375.5,364.7,374,365.2,371.2z"/>
	<path className="st01 two-text" d="M372.4,374.7c0-0.5,0.1-1,0.1-1.5l3.7-21.1h3.2l-3.7,21.1c0,0.2,0,0.5,0,0.7c0,1,0.8,1.3,1.6,1.3
		c0.7,0,1.5-0.1,2.2-0.1l-0.4,2.4c-1,0.3-2,0.4-3,0.4C373.5,377.9,372.4,376.6,372.4,374.7z"/>
	<path className="st01 two-text" d="M382.1,372.6c0-0.5,0.1-0.9,0.1-1.5l0.8-4.5c0.8-4.5,4.7-7.4,9.1-7.4c3.8,0,6.7,2,6.7,5.8
		c0,0.5-0.1,1.1-0.1,1.6l-0.7,4.2c-0.8,4.5-4.6,7.4-9,7.4C385.2,378.2,382.1,376.4,382.1,372.6z M394.7,371l0.8-4.7
		c0.1-0.4,0.1-0.7,0.1-1c0-2.2-1.6-3.3-3.9-3.3c-2.9,0-4.9,1.8-5.3,4.5l-0.8,4.7c-0.1,0.4-0.1,0.7-0.1,1c0,2.2,1.5,3.3,3.9,3.3
		C392.2,375.5,394.2,373.8,394.7,371z"/>
	<path className="st01 two-text" d="M398.1,384.7l0.5-2.8c0.8,0.1,1.5,0.2,2.1,0.2c1.3,0,2.6-0.9,3.2-2.1l1.4-2.7l-3.7-17.7h3.4l2.6,14h0.1l7-14
		h3.5L406.7,381c-1.7,3.1-3.9,4-6.4,4C399.7,385,399,384.9,398.1,384.7z"/>
	<path className="st01 two-text" d="M418.1,372.4c0-1.3,0.4-2.9,0.8-5.4c0.9-4.8,4.6-7.8,9.3-7.8c3.6,0,6.3,1.8,6.3,5.5c0,1.2-0.3,2.8-0.6,4.7
		h-12.1c-0.3,1.4-0.4,2-0.4,2.6c0,2.3,1.8,3.5,4.2,3.5c2.7,0,4.9-1.2,6-1.9l1,2.1c-1.7,1.6-4.8,2.4-7.7,2.4
		C421.4,378.2,418.1,376.4,418.1,372.4z M431.1,367.1c0.1-1,0.2-1.4,0.2-1.9c0-2.1-1.3-3.3-3.6-3.3c-2.9,0-4.7,1.9-5.3,4.2
		c-0.1,0.2-0.2,0.8-0.2,1L431.1,367.1L431.1,367.1z"/>
	<path className="st01 two-text" d="M436.8,372.9c0-0.5,0-0.9,0.1-1.4l0.9-5.2c0.8-4.5,4-7.1,8.1-7.1c1.9,0,4.2,0.9,4.9,2.9h0.1l1.8-10h3.2
		l-4.5,25.7h-3.1l0.5-2.8h-0.1c-1.5,2.1-4.2,3.2-6.1,3.2C439.1,378.2,436.8,376.3,436.8,372.9z M449.4,370.6l0.7-4.1
		c0.1-0.3,0.1-0.6,0.1-1c0-2.4-1.8-3.7-4-3.7c-2.4,0-4.6,1.5-5.1,4.2l-1,5.3c0,0.3-0.1,0.5-0.1,0.8c0,2.1,1.5,3.2,3.7,3.2
		C446.3,375.4,448.9,373.6,449.4,370.6z"/>
	<path className="st01 two-text" d="M467.2,359.5h3.1l-0.5,2.6h0.1c1.5-1.9,3.9-3,6-3c3.4,0,5.7,1.9,5.7,5.3c0,0.5,0,0.9-0.1,1.4
		c-0.2,1.1-0.8,4.2-0.9,5.2c-0.8,4.5-4.2,7.1-8.4,7.1c-1.9,0-3.9-1.1-4.5-3h-0.1l-1.7,9.5h-3.2L467.2,359.5z M477.4,371.2l0.9-5.3
		c0.1-0.3,0.1-0.5,0.1-0.8c0-2.1-1.7-3.2-3.9-3.2c-2.5,0-5,2-5.5,4.9l-0.7,4c0,0.3-0.1,0.6-0.1,0.9c0,2.4,1.8,3.7,4,3.7
		C474.7,375.5,476.9,374,477.4,371.2z"/>
	<path className="st01 two-text" d="M483.8,372.4c0-1.3,0.4-2.9,0.8-5.4c0.9-4.8,4.6-7.8,9.3-7.8c3.6,0,6.3,1.8,6.3,5.5c0,1.2-0.3,2.8-0.6,4.7
		h-12.1c-0.3,1.4-0.4,2-0.4,2.6c0,2.3,1.8,3.5,4.2,3.5c2.7,0,4.9-1.2,6-1.9l1,2.1c-1.7,1.6-4.8,2.4-7.7,2.4
		C487.1,378.2,483.8,376.4,483.8,372.4z M496.8,367.1c0.1-1,0.2-1.4,0.2-1.9c0-2.1-1.3-3.3-3.6-3.3c-2.9,0-4.7,1.9-5.3,4.2
		c-0.1,0.2-0.2,0.8-0.2,1L496.8,367.1L496.8,367.1z"/>
	<path className="st01 two-text" d="M502.5,372.6c0-0.5,0.1-0.9,0.1-1.5l0.8-4.5c0.8-4.5,4.7-7.4,9.1-7.4c3.8,0,6.7,2,6.7,5.8
		c0,0.5-0.1,1.1-0.1,1.6l-0.7,4.2c-0.8,4.5-4.6,7.4-9,7.4C505.6,378.2,502.5,376.4,502.5,372.6z M515.1,371l0.8-4.7
		c0.1-0.4,0.1-0.7,0.1-1c0-2.2-1.6-3.3-3.9-3.3c-2.9,0-4.9,1.8-5.3,4.5l-0.8,4.7c-0.1,0.4-0.1,0.7-0.1,1c0,2.2,1.5,3.3,3.9,3.3
		C512.6,375.5,514.6,373.8,515.1,371z"/>
	<path className="st01 two-text" d="M524.6,359.5h3.1l-0.5,2.6h0.1c1.5-1.9,3.9-3,6-3c3.4,0,5.7,1.9,5.7,5.3c0,0.5,0,0.9-0.1,1.4
		c-0.2,1.1-0.8,4.2-0.9,5.2c-0.8,4.5-4.2,7.1-8.4,7.1c-1.9,0-3.9-1.1-4.5-3H525l-1.7,9.5h-3.2L524.6,359.5z M534.8,371.2l0.9-5.3
		c0.1-0.3,0.1-0.5,0.1-0.8c0-2.1-1.7-3.2-3.9-3.2c-2.5,0-5,2-5.5,4.9l-0.7,4c0,0.3-0.1,0.6-0.1,0.9c0,2.4,1.8,3.7,4,3.7
		C532,375.5,534.2,374,534.8,371.2z"/>
	<path className="st01 two-text" d="M541.9,374.7c0-0.5,0.1-1,0.1-1.5l3.7-21.1h3.2l-3.7,21.1c0,0.2,0,0.5,0,0.7c0,1,0.8,1.3,1.6,1.3
		c0.7,0,1.5-0.1,2.2-0.1l-0.4,2.4c-1,0.3-2,0.4-3,0.4C543.1,377.9,541.9,376.6,541.9,374.7z"/>
	<path className="st01 two-text" d="M551.7,372.4c0-1.3,0.4-2.9,0.8-5.4c0.9-4.8,4.6-7.8,9.3-7.8c3.6,0,6.3,1.8,6.3,5.5c0,1.2-0.3,2.8-0.6,4.7
		h-12.1c-0.3,1.4-0.4,2-0.4,2.6c0,2.3,1.8,3.5,4.2,3.5c2.7,0,4.9-1.2,6-1.9l1,2.1c-1.7,1.6-4.8,2.4-7.7,2.4
		C554.9,378.2,551.7,376.4,551.7,372.4z M564.7,367.1c0.1-1,0.2-1.4,0.2-1.9c0-2.1-1.3-3.3-3.6-3.3c-2.9,0-4.7,1.9-5.3,4.2
		c-0.1,0.2-0.2,0.8-0.2,1L564.7,367.1L564.7,367.1z"/>
</g>
<g>
	<g>
		<path className="st14" d="M805.8,345.9c7.6,0,10.7,4,10.7,8.7c0,4.3-2.2,7.2-5,9c4,1.4,5.6,4.5,5.6,8.3c0,5.4-3.7,10.8-12.3,10.8
			c-4.7,0-9.1-1.5-11.1-2.9l1.9-4.9c2.4,1.3,5.6,2.5,8.6,2.5c3.7,0,6.1-2.1,6.1-5.7c0-4.1-2.7-5.2-7.8-5.2h-2.4l0.5-4.6h5.4
			c1.8-0.9,3.6-3.2,3.6-6.3c0-3-1.9-4.5-5.1-4.5c-1.5,0-3,0.2-3.7,0.5c-0.8,0.3-1,0.7-1,1.7v3.5l-5.3-0.4v-8
			C797.6,346.9,801.5,345.9,805.8,345.9z"/>
		<path className="st14" d="M824.6,346.6H836c1.2,0,1.4-0.4,1.4-1.5v-2.3l5.3,0.4v8.1h-12.9l-1.2,9.2c7.3,0.4,14.4,3.3,14.4,11.1
			c0,5.2-3.2,11-12.7,11c-4.2,0-9.1-1.6-10.9-3l2-4.9c2.1,1.2,5.3,2.6,8.7,2.6c4.5,0,6.2-2.5,6.2-5.6c0-6-8.5-6.8-14-6.8
			L824.6,346.6z"/>
		<path className="st14" d="M851.9,391l-3.6-1.2l2.2-7c0.3-1.2-0.1-1.5-1.1-1.5h-1.8l1.1-5.1c1.1-0.3,2.1-0.4,3-0.4
			c3.3-0.1,5,1.5,5.1,3.8c0,1-0.2,2.1-0.8,3.3L851.9,391z"/>
		<path className="st14" d="M886.4,364c0,13-4.6,18.6-13,18.6s-12.7-5.6-12.7-18.4c0-12.6,5.2-18.3,13.1-18.3
			C881.6,345.9,886.4,351,886.4,364z M879.9,364.1c0-10.1-2.5-12.9-6.2-12.9c-4,0-6.3,3.1-6.3,13.5c0,9.6,2.3,12.5,6.2,12.5
			C877.3,377.3,879.9,374.6,879.9,364.1z"/>
		<path className="st14" d="M916.1,364c0,13-4.6,18.6-13,18.6s-12.7-5.6-12.7-18.4c0-12.6,5.2-18.3,13.1-18.3
			C911.3,345.9,916.1,351,916.1,364z M909.6,364.1c0-10.1-2.5-12.9-6.2-12.9c-4,0-6.3,3.1-6.3,13.5c0,9.6,2.3,12.5,6.2,12.5
			C907,377.3,909.6,374.6,909.6,364.1z"/>
		<path className="st14" d="M945.8,364c0,13-4.6,18.6-13,18.6s-12.7-5.6-12.7-18.4c0-12.6,5.2-18.3,13.1-18.3
			C941,345.9,945.8,351,945.8,364z M939.3,364.1c0-10.1-2.5-12.9-6.2-12.9c-4,0-6.3,3.1-6.3,13.5c0,9.6,2.3,12.5,6.2,12.5
			C936.7,377.3,939.3,374.6,939.3,364.1z"/>
	</g>
</g>
</svg>


</div>

 );
        }
}

class MainContent extends React.Component {
        render() {
          return (
          	<div>
          		<div className="container">
				  <div className="infobox-video">
				    <div className="row pad-top-40">
				      <div className="col-sm-12">
				        <h1><span className="video-bg">Our Eye on the Ball</span></h1>

				      </div>
				    </div>
				  </div>
				</div>


				<div className="container">
				  <div className="infobox">
				    <div className="row">
						<div className="col-sm-1"></div>
				      <div className="col-sm-10">
					  
						  <p className="flamaitalic font24 pad-bot-20">MVP helps businesses across the nation manage their staffing needs. We strive to understand your needs and find the right the solution, from general labor to permanent placements. We work with speed, focus and efficiency to find the best candidates and integrate them into your operations. </p>
						  <p className="flamalight font21">MVP started in 2000 in Florida with one office. We now do business in 44 states. Companies ranging from small businesses to national retailers depend on us. We employ more than 35,000 people and many have been with us for more than five years. </p>
						  	<AboutSvg />
						  <p className="flamalight font21">We take pride in the quality and stability of our work force, which allows us to be nimble and accommodate our clients’ evolving demands. We’re dedicated to partnering with our clients to make the search for reliable, quality workers as seamless as possible.</p>
						  <p className="flamalight font21">MVP goes beyond recruitment and hiring to offer a fully integrated suite of services, including payroll and benefits, on-site supervision and workers’ compensation insurance. This reduces risk and paperwork and gives clients’ more control over costs.</p>
						  <p className="flamaitalic font24 pad-top-20">The MVP team includes experienced, motivated and vested principals with a track record of helping businesses keep their full-time, in-house staffing lean and flexible enough to adapt to new ideas or changes in demand.</p>

				      </div>
				    </div>
				  </div>
				</div>
          	</div>
          );
        }
}




function Abouts() {
  return (
  <div>
      <Banner />
      <MainContent />
  </div>    
  );
}


export default Abouts



// WEBPACK FOOTER //
// ./src/about.js